<nb-card style="min-width: 28rem;">
  <nb-card-header class="text-center">
    <h6><nb-icon icon="trash-2-outline" class="mr-2"></nb-icon>{{ 'stepper.ticket.cancelBooking' | translate }}</h6>
  </nb-card-header>
  <nb-card-body style="padding: 1.5rem;">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;" *ngIf="data.serviceTitle">
      <div style="display: flex; align-items: center; gap: 0.25rem; color: var(--color-primary-400);">
        <nb-icon icon="briefcase-outline"></nb-icon>
        <span>{{ 'common.service' | translate }}</span>
      </div>
      <strong>{{ data.serviceTitle }}</strong>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;" *ngIf="data.deliveryCenterTitle">
      <div style="display: flex; align-items: center; gap: 0.25rem; color: var(--color-primary-400);">
        <nb-icon icon="pin-outline"></nb-icon>
        <span>{{ 'common.sede' | translate }}</span>
      </div>
      <strong>{{ data.deliveryCenterTitle }}</strong>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
      <div style="display: flex; align-items: center; gap: 0.25rem; color: var(--color-primary-400);">
        <nb-icon icon="calendar-outline"></nb-icon>
        <span>{{ 'common.date' | translate }}</span>
      </div>
      <strong>{{ data.bookingDateTime | date : 'dd/MM/yyyy HH:mm' }}</strong>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: flex-start;" *ngIf="data.subjects && data.subjects.length">
      <div style="display: flex; align-items: center; gap: 0.25rem; color: var(--color-primary-400);">
        <nb-icon icon="book-open-outline"></nb-icon>
        <span>{{ 'common.subjects' | translate }}</span>
      </div>
      <div style="text-align: right;">
        <strong *ngFor="let s of data.subjects" style="display: block;">{{ s }}</strong>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer class="text-center">
    <p>{{ 'stepper.ticket.confirmCancel' | translate }}</p>
    <div class="d-flex justify-content-center" style="gap: 1.5rem;">
      <button nbButton outline status="primary" shape="round" type="button" (click)="close()">{{ 'common.back' | translate }}</button>
      <button nbButton status="primary" shape="round" type="button" (click)="confirm()">{{ 'stepper.ticket.cancelBooking' | translate }}</button>
    </div>
  </nb-card-footer>
</nb-card>
